// BE-601: регистрируем данные ru-локали до бутстрапа — гасит NG0701 (Missing locale data)
// в местах с Angular-локализацией дат/чисел ('ru'/'ru-RU'). Должно идти первым импортом.
import './app/core/i18n/register-locale';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { ThemeService } from './app/core/services/theme.service';
import { initSentry } from './app/core/observability/sentry-init';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

// Прогрев холодного DNS+TCP+TLS к API-origin (единственный host на критическом пути;
// статика идёт с web-origin) — параллельно с бутстрапом, до первого запроса. Origin
// берём из РЕАЛЬНОГО environment.apiBaseUrl (единый источник, env-aware:
// test→api.test.zhmyak.ru, prod→api.zhmyak.ru), а не из хардкода/конвенции в index.html.
preconnectToApiOrigin();

// Инициализируем тему перед запуском приложения
const themeService = new ThemeService();
initSentry();

bootstrapApplication(App, appConfig)
  .catch((err) => {
    Sentry.captureException(err);
    console.error(err);
  });

function preconnectToApiOrigin(): void {
  try {
    const origin = new URL(environment.apiBaseUrl).origin;
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    link.crossOrigin = '';
    document.head.appendChild(link);
  } catch {
    // невалидный apiBaseUrl — просто без прогрева, не валим старт
  }
}
